import { httpClientScreenBuilder, httpClientLeadService } from '../utils/http.client';

const LOB_BASE_URL = '/v1/lob';
const LOB_PRODUCT_BASE_URL = '/v1/lob-product';

/**
 * LOB Service - Handles all Line of Business API calls
 */
export const lobService = {
  /**
   * Get active LOBs with their LIVE products (for lead generation)
   * @param {Object} params - Query parameters
   * @returns {Promise} API response
   */
  getActiveLOBsWithLiveProducts: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);

      const url = `${LOB_PRODUCT_BASE_URL}/active-lobs-with-live-products${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await httpClientLeadService.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  /**
   * Get all Lines of Business with pagination and filters
   * @param {Object} params - Query parameters
   * @returns {Promise} API response
   */
  getAllLOBs: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.search) queryParams.append('search', params.search);
      if (params.sortBy) queryParams.append('sortBy', params.sortBy);
      if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
      if (params.is_active !== undefined) queryParams.append('is_active', params.is_active);

      const url = `${LOB_BASE_URL}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await httpClientScreenBuilder.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Get a specific Line of Business by ID
   * @param {string} lobId - LOB ID
   * @returns {Promise} API response
   */
  getLOBById: async (lobId) => {
    try {
      const response = await httpClientScreenBuilder.get(`${LOB_BASE_URL}/${lobId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Create a new Line of Business
   * @param {Object} lobData - LOB creation data
   * @returns {Promise} API response
   */
  createLOB: async (lobData) => {
    try {
      const response = await httpClientScreenBuilder.post(LOB_BASE_URL, lobData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Update an existing Line of Business
   * @param {string} lobId - LOB ID
   * @param {Object} lobData - LOB update data
   * @returns {Promise} API response
   */
  updateLOB: async (lobId, lobData) => {
    try {
      const response = await httpClientScreenBuilder.put(`${LOB_BASE_URL}/${lobId}`, lobData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Delete a Line of Business
   * @param {string} lobId - LOB ID
   * @returns {Promise} API response
   */
  deleteLOB: async (lobId) => {
    try {
      const response = await httpClientScreenBuilder.delete(`${LOB_BASE_URL}/${lobId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Activate a Line of Business
   * @param {string} lobId - LOB ID
   * @returns {Promise} API response
   */
  activateLOB: async (lobId) => {
    try {
      const response = await httpClientScreenBuilder.put(`${LOB_BASE_URL}/${lobId}/activate`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Deactivate a Line of Business
   * @param {string} lobId - LOB ID
   * @returns {Promise} API response
   */
  deactivateLOB: async (lobId) => {
    try {
      const response = await httpClientScreenBuilder.put(`${LOB_BASE_URL}/${lobId}/deactivate`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
